import React from 'react'
import { MdOutlinePhone } from "react-icons/md";
import { FaEnvelope } from "react-icons/fa";
import { MdLocationPin } from "react-icons/md";

const Navbar = () => {
  return (
    <>
    <div className='h-[8vh] w-full bg-gray-800 text-white flex justify-center'>
    <div className='   p-3 max-[768px]:w-full max-[425px]:text-xs'>
           <li className='list-none flex items-center justify-center gap-x-4 max-[425px]:gap-x-1'>
            <ul className='flex items-center gap-x-3'>
            <MdOutlinePhone className='text-yellow-500 text-2xl'/>
            <p>01491 529777</p>
            </ul>
            <ul className='flex items-center gap-x-3'>
            {/* <MdOutlinePhone className='text-yellow-500 text-2xl' /> */}
            {/* <p>01491 529777</p> */}
            </ul>
            <ul className='flex items-center gap-x-3'>
            <FaEnvelope  className='text-yellow-500 text-2xl' />
            <p>akaytaxis@gmail.com</p>
            </ul>
            <ul className='flex items-center gap-x-3'>
            <MdLocationPin  className='text-yellow-500 text-2xl max-[768px]:text-sm max-[700px]:hidden'/>
            <p className='max-[768px]:text-sm max-[700px]:hidden'>3 castle Street 
Wallingford 
Ox108dl</p>
            </ul>
            </li> 
    </div>   
    </div>
    
    </>
  )
}

export default Navbar